import { useQuery } from "react-query";

import axiosInstance from "../../../../api/axiosInstance";
import query from "../../../../api/constants.api";
import { serializeSubCategories } from "../../../../api/helpers.api";
import { useGlobalStateContext } from "../../../../contexts/GlobalStateContext";

const useFetchSubCategories = () => {
    const { globalState: { selectedBusinessId } } = useGlobalStateContext();

    // Step 1: fetch subcategory id using the category id (selectedBusinessId)
    const fetchSubcategoryId = () => {
        const params = { sysparm_fields: 'u_class_digital_twin,name,sys_id', sysparm_display_value: 'all', sys_id: selectedBusinessId, company: 'NOVA - Campus de Campolide' };

        return axiosInstance('GET', query.path.cityService, null, params, 'application/json')
    }

    const { data: dataId, isLoading: loadingId } = useQuery(['fetchSubcategoryId', selectedBusinessId], fetchSubcategoryId, {
        refetchOnWindowFocus: false,
    })

    // Step 2: fetch the dropdown menu data using the previously fetched subcategory id
    const fetchSubcategories = (id: string | number | null) => {
        const params = {
            sysparm_fields: 'u_category,u_class_digital_twin',
            sysparm_display_value: 'all',
            u_class_digital_twin: id,
            u_domain: '03c54e1a8718591050cd87f5cebb35d9',
            company: 'NOVA - Campus de Campolide',
        };
        return axiosInstance('GET', query.path.synergyCategory, null, params, 'application/json')
    }

    const subCategoryId = dataId?.data.result[0]?.u_class_digital_twin?.value;

    const { data: dropdownData, isLoading: loadingSubCategories } = useQuery(['fetchSubcategories', subCategoryId], () => fetchSubcategories(subCategoryId), {
        enabled: !!subCategoryId,
        refetchOnWindowFocus: false,
        select: (data) => serializeSubCategories(data?.data.result),
    })

    return { dropdownData, isLoading: loadingId || loadingSubCategories };
}

export default useFetchSubCategories;